import {createTemplatesFromFIG} from "@frontend/group/modules/fig-layers/strategies/create-templates";

export class FigStrategy {
  static FLOWS = {
    PARSE: 'PARSE',
    CREATE_TEMPLATES: 'CREATE_TEMPLATES',
  }
  static FLOW_HANDLERS = {
    [this.FLOWS.CREATE_TEMPLATES]: createTemplatesFromFIG
  }
  
  
  static async run(flow, { state }) {
    const flowHandler = this.FLOW_HANDLERS[flow];
    
    if (!flowHandler) {
      throw new Error('Invalid flow!');
    }

    const filesDTO = state.files.map(fileState => {
      return {
        data: fileState.data,
        absoluteFilename: fileState.filename
      }
    });
    
    await flowHandler(filesDTO);
  }
}
